/* eslint-disable @typescript-eslint/no-unused-vars */
import ReactDOM from "react-dom/client";
import App from "./App";
import "./components/css/index.css";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LogoutProvider } from "services/LogoutProvider";
import UnauthorizedPopup from "components/elements/UnauthorizedPopup";
import SessionExpiredPopup from "components/elements/SessionExpiredPopup";
import AppExitPopup from "components/elements/AppExitPopup";
import { StorageProvider } from "services/StorageProvider";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { AnalyticsProvider } from "services/AnalyticsProvider";

const queryClient = new QueryClient();
const root: ReactDOM.Root = ReactDOM.createRoot(
  document.getElementById("root")!,
);

root.render(
  <QueryClientProvider client={queryClient}>
    <LogoutProvider>
      <UnauthorizedPopup />
      <SessionExpiredPopup />
      <AppExitPopup />
      <StorageProvider>
        <AnalyticsProvider>
          <App />
        </AnalyticsProvider>
      </StorageProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </LogoutProvider>
  </QueryClientProvider>,
);

// Register service worker HERE (after render)
if ("serviceWorker" in navigator) {
  serviceWorkerRegistration.register();
}

reportWebVitals(console.log);
